import React from "react";
import { Grid } from "@material-ui/core";
import { useQuery } from "react-query";
import { useFirebase } from "../Firebase";
import { useError } from "../ErrorProvider";
import Table from "../StyledComponents/MaterialTable";
import { PageHeader, TableSkeleton } from "../UI";

const Winners = () => {
  const firebase = useFirebase();
  const { showError } = useError();

  const { data, isLoading } = useQuery(
    "CompanyWinners",
    firebase.getCompanyWinners,
    {
      select: (data) => data?.data,
      onError: (err) => showError(err),
    }
  );

  const cols = [
    {
      title: "Date",
      field: "drawingDate",
      type: "datetime",
      defaultSort: "desc",
      customSort: (a, b) => {
        return new Date(a.drawingDate) - new Date(b.drawingDate);
      },
    },
    {
      title: "Name",
      field: "firstName",
      render: (rowData) => {
        return `${rowData.firstName} ${rowData.lastName}`;
      },
    },
    {
      title: "Email",
      field: "email",
    },
    {
      title: "Type",
      field: "quarterlyWinner",
      render: (rowData) => (rowData.quarterlyWinner ? "Quarterly" : "Weekly"),
    },
  ];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <PageHeader title="Winners" />
      </Grid>
      <Grid item xs={12}>
        {isLoading ? (
          <TableSkeleton rows={8} />
        ) : (
          <Table
            columns={cols}
            data={data || []}
            localization={{
              body: {
                emptyDataSourceMessage:
                  "No winners yet — drawing results appear here every Monday.",
              },
            }}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default Winners;
